import dayjs from 'dayjs'
import en from '#src/translations/en.json'
import Logger from '#helpers/logging/Logger.js'
import { createI18n } from 'vue-i18n'
import { datetimeFormats } from '#src/translations/locales.js'
import { supportedLanguages } from '#src/constants/supportedLanguages.js'

export const i18n = createI18n({
	legacy: false,
	locale: 'en', // set locale
	fallbackLocale: import.meta.env.PROD ? 'en' : 'debug',
	messages: { en }, // set locale messages
	datetimeFormats
})

/**
 * @param {string} locale - The locale to set in the system
 * @returns {Promise<void>}
 */
export async function setI18nLanguage(locale) {
	Logger.debug('setI18nLanguage', locale)
	// don't do anything when the language is not supported
	if (!supportedLanguages.includes(locale)) { return }

	// if the language is not yet loaded in,
	if (!i18n.global.availableLocales.includes(locale)) {
		// async load it
		const messages = await importTranslationFile(locale)
		Logger.debug(`#src/translations/${locale}.json loaded`)
		// add it to the available locales
		i18n.global.setLocaleMessage(locale, messages.default)
	}

	// set i18n locale
	i18n.global.locale.value = locale
	// set localstorage locale
	localStorage.language = locale
	// set dayjs locale
	dayjs.locale(locale)
	// set dom locale
	document.querySelector('html').setAttribute('lang', locale)
}

/**
 * @param {string} locale - The locale for the file to load
 * @returns {Promise} - The loaded file
 */
async function importTranslationFile(locale) {
	switch(locale) {
		case 'cs': return await import('#src/translations/cs.json')
		case 'da': return await import('#src/translations/da.json')
		case 'de': return await import('#src/translations/de.json')
		case 'es': return await import('#src/translations/es.json')
		case 'fr': return await import('#src/translations/fr.json')
		case 'it': return await import('#src/translations/it.json')
		case 'nl': return await import('#src/translations/nl.json')
		case 'pl': return await import('#src/translations/pl.json')
		case 'pt': return await import('#src/translations/pt.json')
		case 'sv': return await import('#src/translations/sv.json')
		default: return await import('#src/translations/en.json')
	}
}

/**
 * @type {object[]}
 */
export const languages = [
	{
		name: 'Nederlands',
		code: 'nl',
		dateFormat: 'DD-MM-YYYY',
	},
	{
		name: 'English',
		code: 'en',
		dateFormat: 'MM-DD-YYYY',
	},
	{
		name: 'Français',
		code: 'fr',
		dateFormat: 'DD-MM-YYYY',
	}
]
